<template lang='pug' src='./navigation.pug'></template>

<script>
import Icon from 'components/icon/icon'
import FunctionButton2 from 'components/block/block-function-button-2/block-function-button-2'

export default {
  data () {
    return {
      isOpen: false
    }
  },
  computed: {
    props () {
      return this.$store.state.pages.nav
    },
    links () {
      return this.$router.options.routes
    },
    button () {
      return {
        path: '/contact-us',
        name: 'Contact Us'
      }
    },
    functionButton () {
      return [
        {
          label: 'Make Appointment'
        }
      ]
    }
  },
  methods: {
    openModal (e) {
      this.$store.dispatch('VIEW_SHOWMODAL', true)
      this.$store.dispatch('VIEW_MODALCONTENT', e)
    },
    dropdown () {
      this.isOpen = !this.isOpen
      console.log('isOpen: ', this.isOpen)
    }
  },
  components: {
    Icon,
    FunctionButton2
  }
}
</script>



// WEBPACK FOOTER //
// navigation.vue?26c01f3e